import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import DatePicker from 'react-datepicker';

import { constants } from '@nhl/formatter-utilities';

import { playersOperations } from '../../../redux/ducks/players';

import HeadshotInfo from 'media-base-ui/views/components/headshotInfo';
import BasePlayerTeamInfo from 'media-base-ui/views/components/headshotInfo/components/BasePlayerTeamInfo';
import SingleValuePlayerStat from 'media-base-ui/views/components/headshotInfo/components/SingleValuePlayerStat';
import { sortByDate } from 'media-base-ui/utils/sort';
import { componentSeasonSelectors } from 'media-base-ui/redux/ducks/componentSeason';
import ComponentSeasonIdentifiers from 'media-base-ui/utils/componentSeasonIdentifiers';

import DatePickerCustomInput from './DatePickerCustomInput';

import './styles.scss';

const Birthday = () => {
    const dispatch = useDispatch();
    const season = parseFloat(componentSeasonSelectors(ComponentSeasonIdentifiers.TEAMS).season);
    const playersState = useSelector(({players}) => players.playersState);
    const [startDate, setStartDate] = useState(moment());

    useEffect(() => {
        dispatch(playersOperations.fetchPlayersByBirthday(startDate.month() + 1, startDate.date(), season));
        return () => {
            dispatch(playersOperations.flushCache(constants.BIRTHDAY_FAKE_TEAM));
        }
    }, []);

    const handleChange = (date) => {
        setStartDate(date);
        dispatch(playersOperations.fetchPlayersByBirthday(date.month() + 1, date.date(), season));
    };

    let { players } = playersState;
    players = players[constants.BIRTHDAY_FAKE_TEAM] || [];
    players = players.filter(player => player.currentTeam).map(player => {
        const modPlayer = {...player};
        modPlayer.birthDate = moment()
            .month(player.birthMonth - 1)
            .date(player.birthDay)
            .year(player.birthYear)
            .startOf('day')
            .format(constants.DATE_FORMAT);
        return modPlayer;
    });

    const sortedPlayers = sortByDate(players, 'birthDate', constants.DATE_FORMAT);

    const birthdayHeaderString = `
        ${moment(startDate).format("L") === moment().format("L") 
            ? 'Today\'s' 
            : moment(startDate).format("LL")} 
                Birthday${players.length > 1 
                    ? 's' 
                    : ''}
    `;

    return (
        <div className="birthday-module-container white">

            <div className={'birthday-header'}>
                <h3>{birthdayHeaderString}</h3>
                <DatePicker
                    todayButton={'Today'}
                    selected={startDate}
                    onChange={handleChange}
                    popperPlacement="bottom-end"
                    customInput={
                        <DatePickerCustomInput />
                    }
                />
            </div>

            <div className="birthday-player-list">
                {players.length > 0
                    ?   sortedPlayers.map(player => (
                            <HeadshotInfo
                                key={player.id}
                                player={player}
                                team={player.currentTeam}
                                season={season}
                                size={60}
                                baseInfoComponent={
                                    <BasePlayerTeamInfo
                                        player={player}
                                        team={player.currentTeam}
                                        season={season}
                                    />
                                }
                                dataComponent={
                                    <SingleValuePlayerStat
                                        title="Age"
                                        value={startDate.diff(moment(player.birthDate), 'years')}
                                    />
                                }
                            />
                        ))
                    :   'No Birthdays Today'
                }
            </div>
        </div>
    )
};

export default Birthday;
